import React, {useState, useCallback, useEffect} from 'react';
import {Button, Input, Space, Table} from 'antd';
import Api from "../../api";
import HistoryModal from "./modal";
import {toTime} from "../../util/time";
import defaultAvatar from "../../assets/img/avatar.png";


export default function StudentIndex() {

    const [list, setList] = useState([])
    const [pageIndex, setPageIndex] = useState(1)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [curStudentId, setCurStudentId] = useState()
    const [searchOptions, setSearchOptions] = useState({})

    useEffect(() => {
        loadData();
    }, [pageIndex])

    const doSearch = useCallback((options) => {
        setSearchOptions(options)
        loadData(true, options)
    })


    const loadData = useCallback((reset = false, params = {}) => {
        if (loading) return;
        setLoading(true)
        Api.getStudentList({
            ...searchOptions,
            ...params,
            pageIndex: reset ? 1 : pageIndex
        }).then(resp => {
            setLoading(false)
            setList(resp.list || [])
            setPageIndex(resp.pageIndex)
            setTotal(resp.totalCount)
        })
    })

    const columns = [
        {
            title: '编号',
            key: 'id',
            render: (_, record) => {
                return <span>{record.studentId}</span>
            }
        },
        {
            title: '昵称',
            key: 'name',
            render: (_, record) => {
                return <div className="flexbox align-center">
                    <img style={{width: 40, height: 40, borderRadius: 20}} src={record.headImg||defaultAvatar}/>
                    <span className="mgl10 bold">{record.nickname}</span>
                </div>
            }
        },
        {
            title: '手机号',
            key: 'name',
            render: (_, record) => {
                return <span>{record.mobile}</span>
            }
        }, {
            title: '最后登录时间',
            key: 'createTime',
            render: (_, record) => {
                return <span>{toTime(record.loginTime || record.createTime)}</span>
            }
        },
        {
            title: '操作',
            key: 'action',
            render: (_, record) => (
                <Space size="middle" wrap>
                    <a onClick={()=>openModal(record.studentId)}>观看记录</a>
                </Space>
            ),
        },
    ];

    const [showModal, setShowModal] = useState(false)
    const openModal = useCallback((id) => {
        setCurStudentId(id)
        setShowModal(true)
    })
    const onModalClose = useCallback((data) => {
        setShowModal(false)

    })


    return (
        <>
            <div style={{minWidth: 800, maxWidth: 1400}}>
                <SearchBar onSearch={doSearch}/>
                <Table
                    columns={columns}
                    dataSource={list}
                    rowKey="studentId"
                    pagination={{
                        total: total,
                        pageSize: 10,
                        onChange: (index) => setPageIndex(index),
                        showSizeChanger:false
                    }}
                />
            </div>
            <HistoryModal id={curStudentId} isShow={showModal} onClose={onModalClose}/>
        </>
    );
};


function SearchBar({onSearch}) {
    const [studentId, setStudentId] = useState()
    const [nickName, setNickName] = useState()
    const [mobile, setMobile] = useState()
    const resetOptions = useCallback(() => {
        setStudentId()
        setNickName()
        setMobile()
    })

    const doSearch = useCallback(() => {
        onSearch && onSearch({
            studentId,
            nickName,
            mobile
        })
    })

    return (
        <div className="white-bg pdh16 pdv32 mgv12">
            <div className="flexbox wrap align-center">
                <div className="mgb12">
                    <span>编号：</span>
                    <Input
                        value={studentId}
                        onChange={(e) => setStudentId(e.target.value)}
                        placeholder="请输入"
                        style={{width: 200, height: 32, marginRight: 32}}/>
                </div>
                <div className="mgb12">
                    <span>昵称：</span>
                    <Input
                        value={nickName}
                        onChange={(e) => setNickName(e.target.value)}
                        placeholder="请输入" style={{width: 200, height: 32, marginRight: 32}}/>
                </div>
                <div className="mgb12">
                    <span>手机：</span>
                    <Input
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        placeholder="请输入" style={{width: 200, height: 32, marginRight: 32}}/>
                </div>
                <Space className="mgb12">
                    <Button type="primary" onClick={doSearch}>查询</Button>
                    <Button onClick={resetOptions}>重置</Button>
                </Space>
            </div>
        </div>
    )
}